var map = {
	"./about.svg": "a85b",
	"./activity.svg": "6736",
	"./add.svg": "c2a3",
	"./agreement.svg": "9467",
	"./apple.svg": "1108",
	"./arrow.svg": "b6e4",
	"./asset.svg": "b538",
	"./asset_s.svg": "92fd",
	"./auth.svg": "4e70",
	"./balance.svg": "b186",
	"./bell.svg": "2fa4",
	"./bill.svg": "548c",
	"./cert.svg": "b1d4",
	"./chat.svg": "22b2",
	"./collect.svg": "a554",
	"./collect_s.svg": "b6f9",
	"./common.svg": "36ad",
	"./copy.svg": "19b6",
	"./dark.svg": "4123",
	"./date.svg": "235f",
	"./deposit.svg": "c44e",
	"./down.svg": "d681",
	"./edit.svg": "aa46",
	"./empty.svg": "c091",
	"./exchanges.svg": "cf45",
	"./googlepay.svg": "b7ba",
	"./gotop.svg": "32d6",
	"./heel.svg": "e790",
	"./heel_s.svg": "2000",
	"./help.svg": "c932",
	"./history.svg": "c023",
	"./home.svg": "6bbe",
	"./home_s.svg": "7ca1",
	"./icon-c2c.svg": "4a90",
	"./icon-convert.svg": "1883",
	"./icon-currency.svg": "5beb",
	"./icon-deposit-crypto.svg": "d9b2",
	"./icon-deposit-usdt.svg": "4317",
	"./icon-finance.svg": "b391",
	"./icon-loan.svg": "42d7",
	"./icon-transfer.svg": "819f",
	"./icon-usdt-rule.svg": "2e64",
	"./icon-usdt-second.svg": "b394",
	"./kline.svg": "aec1",
	"./lang.svg": "e9ae",
	"./legal.svg": "7918",
	"./light.svg": "7748",
	"./market.svg": "3338",
	"./market_s.svg": "78ab",
	"./mine.svg": "e8d1",
	"./move.svg": "2df4",
	"./notice.svg": "fc99",
	"./openAccount.svg": "c19d",
	"./out.svg": "a673",
	"./password.svg": "2a3d",
	"./position.svg": "15be",
	"./postion.svg": "8c99",
	"./property.svg": "dde2",
	"./recharge.svg": "1b54",
	"./recharge_currency.svg": "a3d4",
	"./right.svg": "9a71",
	"./safe.svg": "bd01",
	"./search.svg": "8e8d",
	"./service.svg": "4e04",
	"./share.svg": "5306",
	"./theme.svg": "e534",
	"./top.svg": "deee",
	"./trade.svg": "07d5",
	"./transfer.svg": "e1d1",
	"./up.svg": "1380",
	"./usdt.svg": "0f75",
	"./user.svg": "b3b5",
	"./vip.svg": "1296",
	"./vip_fill.svg": "4fe3",
	"./with.svg": "07a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";